import { groq } from 'next-sanity'

export const createPerfMetricProjection = () => groq`{
      desktop,
      mobile,
      updatedAt
   }`
